import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const COLLAPSED_PAINTED_DOOR_I18N_NAMESPACE =
  '@mc/next/experiments/prcng-107_v1_collapsed_painted_door'

export const i18nInstance = registerI18nResources({
  namespace: COLLAPSED_PAINTED_DOOR_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
